import React, { Component } from "react";
import moment from "moment";
import { Tabs, Icon, Badge, Modal, Table, Tooltip, message, Progress, Spin, Button, Input } from "antd";

import ConstQueryTable from "../../components/ConstQueryTable";
import ApplyConsulation from "../remoteApply/components/applyConsulation";
import Bookmark from "../remoteApply/bookmark";
import RevokeConsultant from "./revokeConsultant";
import {
	msgNotice,
	urging,
	returnedCase,
	// cancelCollect,
	printPic,
	finishConsultant,
	TransferConsultation,
	completeConsultant,
	GetConsultationPrivilege,
	getUserConsultationRecord,
	cancelCriticalCase
} from "@/request/api";
import "./remoteConsulation.scss";
import star from "../../assets/image/star.png";
import replyicon from "../../assets/image/replyicon.png";
import reporticon from "../../assets/image/reporticon.png";
import moveicon from "../../assets/image/moveicon.png";
import critical from "../../assets/image/critical.png";
import cancelcritical from "../../assets/image/cancelcritical.png";
import dangerFlag from "../../assets/image/dangerFlag.png";
import { fileStatus, getCommonColumnInfoFn, getFileStatus, requestErrorLog } from "../../common/util";
import EditTable from "../../components/editTable/index";
import { sendMessage, receiveMessage, initWebSocket } from "@/request/websocket";
import { getCancelCollect } from "@/common/common";
import CriticalCaseInfo from "../remoteApply/criticalModal";
import DeepSeekModal from "../remoteApply/components/deepSeekModal";


const { confirm } = Modal;
const { TabPane } = Tabs;
const { TextArea } = Input;

class RemoteConsulation extends Component {
	// 远程会诊
	constructor(props) {
		super(props);
		this.state = {
			queryTableData: [],
			rowData: "",
			visible: false,
			applyVisible: false,
			selectedKeys: "",
			selectedRowKeys: [],
			applyType: "",
			workbenchCount: "",
			consultCount: "",
			currentIndex: 1,
			rowsData: [], //多行数据
			bookmarkVisible: false,
			revokeVisible: false,
			bookmarkdetail: "",
			isEdit: false,
			RowCount: 0,
			PageNo: 1,
			PageSize: 10,
			backreturnvisible: false,
			backreturndetail: "",
			rolePrivilege: [],
			transmiRate: 0,
			downloadMsg: "",
			selectExamUid: 0,
			selectExamUids: [],
			downloadError: [],
			chooseclick: "",
			waitingExamUids: [],
			loadingList: [],
			showKey: this.props.applyTabskey,
			resultstatus: 0,
			showColumn: false, //编辑表头,
			downloadType: 0,
			commonColumn: [],
			initCommonColumn: [
				{
					title: "序号",
					dataIndex: "index",
					key: "index",
					align: "center",
					width: 60,
					isShow: true, //表头列合
					render: (text, record, index) => {
						//生成序号
						return <span>{(this.state.PageNo - 1) * 10 + (index + 1)}</span>;
					}
				},
				{
					title: "报告解读",
					dataIndex: "reportAI",
					key: "reportAI",
					width: 120,
					isShow: true,
					align: "center",
					render: (text, record) => {
						return record.CONSULTATION_STATUS_NAME === "已会诊" ? (
							<Button onClick={() => this.getDeepSeek(record, 0)} className="AIBottonClass">
								一键解读
							</Button>
						) : null;
					},
				},
				{
					title: "诊疗建议",
					dataIndex: "suggestAI",
					key: "suggestAI",
					width: 120,
					isShow: true,
					align: "center",
					render: (text, record) => {
						return record.CONSULTATION_STATUS_NAME === "已会诊" ? (
							<Button onClick={() => this.getDeepSeek(record, 1)} className="AIBottonClass">
								查看建议
							</Button>
						) : null;
					},
				},
				{
					title: "传输状态",
					dataIndex: "Progress",
					key: "Progress",
					align: "center",
					width: 160,
					isShow: true, //表头列合
					render: (text, record) => {
						if (this.state.loadingList.some((item) => item.EXAM_UID === record.EXAM_UID)) {
							let value = this.state.loadingList.filter((item) => item.EXAM_UID === record.EXAM_UID)[0];
							if (value.RETURN_RATE) {
								return (
									<div>
										{value.RETURN_MSG === "已报告" ? "下载成功" : value.RETURN_MSG}
										{value.RETURN_RATE && value.RETURN_MSG !== "已报告" ? (
											<Progress percent={parseInt(value.RETURN_RATE)} size="small" />
										) : null}
									</div>
								);
							} else {
								return <div>{value.RETURN_MSG}</div>;
							}
						} else {
							return <div></div>;
						}
					}
				},
				{
					title: "状态标记",
					dataIndex: "DANGER_FLAG",
					key: "DANGER_FLAG",
					width: 80,
					isShow: true,
					align: "center",
					render: (val, record) => {
						return (
							<div style={{ margin: -16, }}>
								{
									record.DANGER_FLAG === 1 &&
									<img className="dangerFlag" key="dangerFlag" src={dangerFlag} alt={"危险"} />
								}
							</div>
						)
					}
				},
				{
					title: "报告状态",
					dataIndex: "EXAM_STATUS_NAME",
					key: "EXAM_STATUS_NAME",
					align: "center",
					width: 80,
					isShow: true, //表头列合
					render: (exam) => (
						<span
							style={{
								color:
									exam === "已审核"
										? "#17CC60"
										: exam === "已报告"
											? "#1A92FF"
											: exam === "未报告"
												? "#FF4045"
												: "#000000a6"
							}}>
							{exam}
						</span>
					)
				},
				{
					title: "会诊状态",
					dataIndex: "CONSULTATION_STATUS",
					key: "CONSULTATION_STATUS",
					align: "center",
					width: 80,
					isShow: true, //表头列合
					render: (exam) => (
						<span
							style={{
								color:
									exam === "2"
										? "#17CC60"
										: exam === "3"
											? "#1A92FF"
											: exam === "1"
												? "#FF4045"
												: exam === "4"
													? "#FFA500"
													: "#0000a6"
							}}>
							{exam === "1"
								? "未会诊"
								: exam === "2"
									? "已会诊"
									: exam === "3"
										? "会诊中"
										: exam === "4"
											? "撤销中"
											: ""}
						</span>
					)
				},
				{
					title: "姓名",
					dataIndex: "NAME",
					key: "NAME",
					align: "center",
					width: 120,
					isShow: true, //表头列合
					ellipsis: true,
					render: (text) => {
						return (
							<Tooltip placement="topLeft" title={text}>
								<span>{text}</span>
							</Tooltip>
						);
					}
				},
				{
					title: "性别",
					dataIndex: "SEX_NAME",
					key: "SEX_NAME",
					align: "center",
					width: 80,
					isShow: true //表头列合
				},
				{
					title: "年龄",
					dataIndex: "AgeDisPlay",
					key: "AgeDisPlay",
					align: "center",
					width: 60,
					isShow: true, //表头列合
					render: (text, record) => {
						return record.EXAM_AGE + record.AGE_UNIT;
					}
				},
				{
					title: "出生日期",
					dataIndex: "BIRTHDAY",
					key: "BIRTHDAY",
					align: "center",
					width: 110,
					isShow: true, //表头列合
					render: (val) => <span>{val && moment(val).format("YYYY-MM-DD")}</span>
				},
				{
					title: "手机号",
					dataIndex: "CONTACT_TEL",
					key: "CONTACT_TEL",
					align: "center",
					width: 120,
					isShow: true
				},
				{
					title: "患者症状",
					dataIndex: "PATIENT_SYMPTOM",
					key: "PATIENT_SYMPTOM",
					align: "center",
					width: 120,
					isShow: true,
					ellipsis: true,
					render: (text) => {
						return (
							<Tooltip placement="topLeft" title={text}>
								<span>{text}</span>
							</Tooltip>
						);
					}
				},
				{
					title: "诊疗建议",
					dataIndex: "EXAM_SUGGEST",
					key: "EXAM_SUGGEST",
					align: "center",
					width: 120,
					isShow: false,
					ellipsis: true,
					render: (text) => {
						return (
							<Tooltip placement="topLeft" title={text}>
								<span>{text}</span>
							</Tooltip>
						);
					}
				},
				{
					title: "病历号",
					dataIndex: "PATIENT_ID",
					key: "PATIENT_ID",
					align: "center",
					width: 120,
					isShow: true //表头列合
				},
				{
					title: "门诊号",
					dataIndex: "OUTP_NO",
					key: "OUTP_NO",
					align: "center",
					width: 120,
					isShow: false //表头列合
				},
				{
					title: "住院号",
					dataIndex: "INP_NO",
					key: "INP_NO",
					align: "center",
					width: 120,
					isShow: false //表头列合
				},
				{
					title: "病区",
					dataIndex: "ROOM_NO",
					key: "ROOM_NO",
					align: "center",
					width: 120,
					isShow: false //表头列合
				},
				{
					title: "床号",
					dataIndex: "BED_NO",
					key: "BED_NO",
					align: "center",
					width: 80,
					isShow: false //表头列合
				},{
					title: "省份",
					dataIndex: "PROVINCE",
					key: "PROVINCE",
					align: "center",
					width: 80,
					ellipsis: true,
					isShow: true, //表头列合
					render: (text) => {
						return (
							<Tooltip placement="topLeft" title={text}>
								<span>{text}</span>
							</Tooltip>
						);
					}
				},
				{
					title: "申请医院",
					dataIndex: "APPLY_HOSPITAL_NAME",
					key: "APPLY_HOSPITAL_NAME",
					align: "center",
					width: 140,
					isShow: true //表头列合
				},
				{
					title: "申请会诊时间",
					dataIndex: "APPLY_DATETIME",
					key: "APPLY_DATETIME",
					align: "center",
					width: 160,
					isShow: true, //表头列合
					sorter: (a, b) => new Date(a.APPLY_DATETIME).getTime() - new Date(b.APPLY_DATETIME).getTime(),
					render: (val) => <span>{val && moment(val).format("YYYY-MM-DD HH:mm:ss")}</span>
				}, 
				{
					title: "医院电话",
					dataIndex: "HOSPITAL_TEL",
					key: "HOSPITAL_TEL",
					align: "center",
					width: 140,
					isShow: true //表头列合
				},
				{
					title: "最终会诊医院",
					dataIndex: "CONSULTATION_HOSPITAL_NAME",
					key: "CONSULTATION_HOSPITAL_NAME",
					align: "center",
					width: 140,
					isShow: true //表头列合
				},
				{
					title: "会诊人",
					dataIndex: "CONSULTATION_DOCTOR_NAME",
					key: "CONSULTATION_DOCTOR_NAME",
					align: "center",
					width: 120,
					isShow: true //表头列合
				},
				{
					title: "完成会诊时间",
					dataIndex: "CONSULTATION_DATE",
					key: "CONSULTATION_DATE",
					width: 160,
					isShow: true, //表头列合
					sorter: (a, b) => new Date(a.CONSULTATION_DATE).getTime() - new Date(b.CONSULTATION_DATE).getTime(),
					render: (val) => <span>{val && moment(val).format("YYYY-MM-DD HH:mm:ss")}</span>
				},
				{
					title: "危急值信息",
					dataIndex: "DANGER_MSG",
					key: "DANGER_MSG",
					align: "center",
					width: 120,
					isShow: true,
					ellipsis: true,
					render: (text) => {
						return (
							<Tooltip placement="left" title={text}>
								<span>{text}</span>
							</Tooltip>
						);
					},
				},
				{
					title: "检查结论",
					dataIndex: "CONCLUSIONS",
					key: "CONCLUSIONS",
					align: "center",
					width: 160,
					isShow: true, //表头列合
					ellipsis: true,
					render: (text) => {
						return (
							<Tooltip placement="topLeft" title={text}>
								<span>{text}</span>
							</Tooltip>
						);
					}
				},
				{
					title: "检查项目",
					dataIndex: "ITEM_NAME",
					key: "ITEM_NAME",
					align: "center",
					width: 120,
					isShow: true, //表头列合
					ellipsis: true,
					render: (text) => {
						return (
							<Tooltip placement="topLeft" title={text}>
								<span>{text}</span>
							</Tooltip>
						);
					}
				},
				{
					title: "一级会诊医院",
					dataIndex: "CONSULTATION_HOSPITAL_NAME1",
					key: "CONSULTATION_HOSPITAL_NAME1",
					align: "center",
					width: 120,
					isShow: true //表头列合
				},
				{
					title: "二级会诊医院",
					dataIndex: "CONSULTATION_HOSPITAL_NAME2",
					key: "CONSULTATION_HOSPITAL_NAME2",
					align: "center",
					width: 120,
					isShow: true //表头列合
				},
				{
					title: "三级会诊医院",
					dataIndex: "CONSULTATION_HOSPITAL_NAME3",
					key: "CONSULTATION_HOSPITAL_NAME3",
					align: "center",
					width: 120,
					isShow: true //表头列合
				},
				{
					title: "撤销原因",
					dataIndex: "REVOKE_REASON",
					key: "REVOKE_REASON",
					align: "center",
					width: 120,
					isShow: true,
					ellipsis: true,
					render: (text) => {
						return (
							<Tooltip placement="topLeft" title={text}>
								<span>{text}</span>
							</Tooltip>
						);
					}
				},
				{
					title: "撤销结果",
					dataIndex: "REVOKE_RESULT",
					key: "REVOKE_RESULT",
					align: "center",
					width: 120,
					isShow: true,
					ellipsis: true,
					render: (text) => {
						return (
							<Tooltip placement="topLeft" title={text}>
								<span>{text}</span>
							</Tooltip>
						);
					}
				},
				{
					title: "书签",
					dataIndex: "COLLECT_TAG",
					key: "COLLECT_TAG",
					align: "center",
					width: 160,
					isShow: true, //表头列合
					ellipsis: true,
					render: (text) => {
						return (
							<Tooltip placement="topLeft" title={text}>
								<span>{text}</span>
							</Tooltip>
						);
					}
				}
			],
			criticalVisible: false,
			deepSeekModalVisible: false,
			deepSeekModalPatientPart: {},
		};
	}

	getDeepSeek = async (record, type) => {//0解读；1建议
		this.setState({
			deepSeekModalVisible: true,
			deepSeekModalPatientPart: record,
			deepSeekModalType: type,
		})
	}
	keepAlive = () => {
		let params = {
			TYPE: "HOLTER",
			PARAM: "GET_FILE_STATES"
		};
		sendMessage(params);

		receiveMessage((data) => {
			// 2025年2月17日修改
			// this.setState({ tabsloading: false });
			if (data.RETURN_VALUE === "文件状态") {
				let arr = getFileStatus(data);
				this.setState({
					loadingList: arr
				});
			} else {
				if (data.RETURN_VALUE !== "RV_SUC_PROGRAM_EXIT" && data.RETURN_VALUE !== "RV_SUC_REPORT") {
					this.getTransferStatus(data);
				}
				if (data.RETURN_MSG === "上传成功") {
					this.refreshTable(); //刷新表格时清除勾选项
					message.success("完成会诊成功！");
				}
				// 顺序判图模式下载成功后打开分析模块
				if (data.RETURN_MSG === "下载成功") {
					this.userConsultationRecord(data);
				}
			}
		});
	};

	verifySignature = (row, e) => {
		e.preventDefault();
		e.stopPropagation();
		this.setState({
			tabsloading: true
		});
		setTimeout(() => {
			this.setState({ tabsloading: false });
		}, 0);
		let params = {
			TYPE: "HOLTER",
			PARAM: "GXCA_SIGNVERIFY",
			EXAM_UID: row.EXAM_UID,
			SERVER: window.g.baseURL
		};
		sendMessage(params);
		receiveMessage((e) => {
			if (e.RETURN_VALUE === "验证CA") {
				if (e.RETURN_MSG === "1") {
					message.success(e.RETURN_RATE);
				} else {
					message.error(e.RETURN_RATE);
				}
			}
		});
	};
	async componentDidMount() {
		let obj = {
			title: "CA验签",
			dataIndex: "view",
			key: "view",
			width: 120,
			isShow: true,
			align: "center",
			render: (text, record) => {
				if (record.CONSULTATION_STATUS_NAME === "已会诊" && record.EXAM_STATUS_NAME === "已审核" && window.g.CA === 2) {
					return (
						<Button onClick={(e) => this.verifySignature(record, e)} className="CABtn">
							CA验签
						</Button>
					);
				}
			}
		};
		if (window.g.CA === 2) {
			let initCommonColumn = this.state.initCommonColumn;
			initCommonColumn.splice(1, 0, obj);
			this.setState(
				{
					initCommonColumn
				},
				() => {
					this.getCommonColumnInfo();
				}
			);
		}
		this.getCommonColumnInfo();
		this.setState({
			rolePrivilege: JSON.parse(localStorage.getItem("roleList")) || []
		});
		await initWebSocket();
		this.keepAlive();
		// 表格设置相关
	}

	canOperation = (data) => {
		let loadingList = this.state.loadingList;
		let status = true;
		data.forEach((elem) => {
			loadingList.forEach((item) => {
				if (item.EXAM_UID === elem.EXAM_UID) {
					status = fileStatus(item.RETURN_MSG);
				}
			});
		});
		if (!status) {
			message.error("该病例正在传输中，无法执行此操作");
			this.setState({ tabsloading: false });
			return false;
		} else {
			return true;
		}
	};

	getTransferStatus = (value) => {
		let loadingList = this.state.loadingList;
		if (loadingList.some((item) => item.EXAM_UID === value.EXAM_UID)) {
			loadingList.forEach((item, index) => {
				if (item.EXAM_UID === value.EXAM_UID) {
					loadingList.splice(index, 1, value);
				}
			});
		} else {
			loadingList.push(value);
		}
		this.setState({
			loadingList,
			tabsloading: false
		});
	};

	/********************动态血压相关开始********************** */
	dynamicBloodDown = (rowData, type) => {
		const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
		const { automaticCompleteConsult = [], printingType = null, signatureType = null, } = JSON.parse(localStorage.getItem("settingValues")) || {};

		let PRIVILEGE = this.getRolePrivilegeFn();

		if (!PRIVILEGE) {
			return;
		}
		this.setState({ tabsloading: true });

		let showKey = parseInt(this.state.showKey);
		let params = {};
		if (rowData.EXAM_STATUS_NAME === "已审核" && rowData.CONSULTATION_STATUS_NAME === "已会诊") {
			params = {
				TYPE: "BLOOD",
				PARAM: "REMOTE_HOSPITAL",
				EXAM_UID: rowData.EXAM_UID,
				NAME: rowData.NAME,
				SERVER: window.g.baseURL,
				USER_INFO: userInfo,
				PRIVILEGE: 2,
				PRINT_HOSPITAL: printingType,
				PRINT_SIGN_TYPE: signatureType
			};
		} else {
			if (showKey === 6) {
				params = {
					TYPE: "BLOOD",
					PARAM: "REMOTE_HOSPITAL",
					EXAM_UID: rowData.EXAM_UID,
					NAME: rowData.NAME,
					SERVER: window.g.baseURL,
					CA_ENABLED: window.g.CA,
					USER_INFO: userInfo,
					PRIVILEGE,
					PRINT_HOSPITAL: printingType,
					PRINT_SIGN_TYPE: signatureType
				};
			} else {
				params = {
					TYPE: "BLOOD",
					PARAM: "REMOTE_CONSULATION",
					EXAM_UID: rowData.EXAM_UID,
					CA_ENABLED: window.g.CA,
					NAME: rowData.NAME,
					SERVER: window.g.baseURL,
					USER_INFO: userInfo
				};
			}
		}
		sendMessage(params);
		receiveMessage(async (data) => {
			this.setState({ tabsloading: false });
			//增加顺序判图模式下载后直接打开
			if (data.RETURN_MSG === "下载成功") {
				this.userConsultationRecord(data);
			}

			if (data.RETURN_VALUE === "RV_SUC_PROGRAM_EXIT") {
				let res = await getCancelCollect(data.EXAM_UID);
				let result = res.Result[0];
				// 已审核且配置自动完成会诊
				if (
					automaticCompleteConsult.includes(data.TYPE) &&
					result.EXAM_STATUS_NAME === "已审核" &&
					result.CONSULTATION_STATUS_NAME !== "已会诊"
				) {
					this.bloodFinished(rowData);
				} else {
					this.refreshTable();
				}
			}
		});
	};

	telemedicineFn = (record, type) => {
		//远程会诊开始报告
		const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
		const rolePrivilege = JSON.parse(localStorage.getItem("roleList")) || {};
		const { automaticCompleteConsult = [], printingType = null, signatureType = null, } = JSON.parse(localStorage.getItem("settingValues")) || {};
		let showkey = parseInt(this.state.showKey);
		let PRIVILEGE = this.getRolePrivilegeFn();
		if (record.CONSULTATION_HOSPITAL_NAME !== userInfo.HOSPITAL_NAME) {
			message.warning("该病例已申请会诊，无法下载");
			this.setState({ tabsloading: false })
			return;
		}
		//如果是在公共池内的病例需要增加验证
		if (showkey <= 3) {
			//如果病例已经是会诊中，则说明已经有会诊人了
			if (record.CONSULTATION_STATUS_NAME === "会诊中") {
				//有会诊人的病例，只有拥有审核权限的人（并且这个病例已经报告了）才能拿到自己的个人工作台审核病例
				if (record.EXAM_STATUS_NAME === "已报告") {
					if (rolePrivilege.indexOf("审核报告") > -1) {
						//并且当前报告的人没有拥有审核权限
						let res = this.state.resultstatus;
						if (res === 1) {
							this.setState({ tabsloading: false })
							message.warning("病例正在会诊中，无法下载");
							this.refreshTable();
							return;
						} else {
							// 执行重复下载传1
							this.setState({ downloadType: 1 })
						}
					} else {
						this.setState({ tabsloading: false })
						message.warning("病例正在会诊中，无法下载");
						return;
					}
				} else {
					this.setState({ tabsloading: false })
					message.warning("病例正在会诊中，无法下载");
					return;
				}
			}
		}
		if (!PRIVILEGE) {
			return;
		}

		if (showkey === 3 || showkey === 6) {
			this.dynamicBloodDown(record);
			return;
		}

		let params = {
			PARAM: "REMOTE_CONSULATION",
			EXAM_UID: record.EXAM_UID,
			NAME: record.NAME,
			SERVER: window.g.baseURL,
			CA_ENABLED: window.g.CA,
			USER_INFO: userInfo,
			DOWNLOAD_TYPE: this.state.downloadType // 下载类型: 0正常下载  1重复下载
		};
		let params1 = {
			PARAM: "REMOTE_HOSPITAL",
			EXAM_UID: record.EXAM_UID,
			NAME: record.NAME,
			SERVER: window.g.baseURL,
			CA_ENABLED: window.g.CA,
			USER_INFO: userInfo,
			PRINT_HOSPITAL: printingType,
			PRINT_SIGN_TYPE: signatureType
		};
		if (record.EXAM_STATUS_NAME === "已审核" && record.CONSULTATION_STATUS_NAME === "已会诊") {
			let data = {
				TYPE: record.EXAM_CLASS === "Holter" ? "HOLTER" : record.EXAM_CLASS === "ECG" ? "ECG" : "",
				PRIVILEGE: 2,
				...params1
			};
			sendMessage(data);
		} else {
			if (showkey === 4 || showkey === 5) {
				let remoteHospital = {
					TYPE: record.EXAM_CLASS === "Holter" ? "HOLTER" : record.EXAM_CLASS === "ECG" ? "ECG" : "",
					PRIVILEGE,
					...params1
				};
				sendMessage(remoteHospital);
			} else {
				let remoteConsult = {
					TYPE: record.EXAM_CLASS === "Holter" ? "HOLTER" : record.EXAM_CLASS === "ECG" ? "ECG" : "",
					...params
				};
				sendMessage(remoteConsult);
			}
		}
		receiveMessage(async (data) => {
			this.setState({
				tabsloading: false
			});
			if (data.RETURN_VALUE !== "RV_SUC_PROGRAM_EXIT" && data.RETURN_VALUE !== "RV_SUC_REPORT") {
				this.getTransferStatus(data);
			}
			if (data.RETURN_VALUE === "RV_SUC_READY_DOWNLOAD" || data.RETURN_VALUE === "RV_SUC_REPORT") {
				this.ConstQueryTable.consultQueryList();
			}
			if (data.RETURN_MSG === "下载成功") {
				this.userConsultationRecord(data);
			}
			if (data.RETURN_VALUE === 'RV_ERR_IN_CONSULTATION') {
				message.warning("病例正在会诊中，无法下载");
			}
			if (data.RETURN_VALUE === "RV_SUC_PROGRAM_EXIT") {
				let res = await getCancelCollect(data.EXAM_UID);
				let result = res.Result[0];
				// 配置自动完成会诊，已审核未会诊的的病例可以完成会诊
				if (
					automaticCompleteConsult.includes(data.TYPE) &&
					result.EXAM_STATUS_NAME === "已审核" &&
					result.CONSULTATION_STATUS_NAME !== "已会诊"
				) {
					this.finishedComplete(record);
				} else {
					this.refreshTable();
				}
			}
		});
	};

	userConsultationRecord = async (data) => {
		const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
		const settingValues = JSON.parse(localStorage.getItem("settingValues")) || {};
		let PRIVILEGE = this.getRolePrivilegeFn();
		let res = await getCancelCollect(data.EXAM_UID);
		let params = {
			PARAM: "REMOTE_HOSPITAL",
			EXAM_UID: data.EXAM_UID,
			NAME: data.NAME,
			SERVER: window.g.baseURL,
			CA_ENABLED: window.g.CA,
			USER_INFO: userInfo,
			PRINT_HOSPITAL: settingValues.printingType,
			PRINT_SIGN_TYPE: settingValues.signatureType
		};
		if (res.Result[0]?.EXAM_STATUS_NAME === "已审核" && res.Result[0]?.CONSULTATION_STATUS_NAME === "已会诊") {
			// 已审核已会诊(动态心电) RV_SUC_HOLTER_DOWNLOAD_INFO先下载原始文件
			if (userInfo.SEQUENCE_ANALYSIS === 1 && data.RETURN_VALUE === "RV_SUC_HOLTER_DOWNLOAD_INFO") {
				let holerData = {
					TYPE: data.TYPE,
					PRIVILEGE: 2,
					...params
				};
				sendMessage(holerData);
			}
		} else {
			// 动态心电、静息心电、动态血压执行打开分析文件
			if (
				userInfo.SEQUENCE_ANALYSIS === 1 &&
				(data.RETURN_VALUE === "RV_SUC_HOLTER_DOWNLOAD" ||
					data.RETURN_VALUE === "RV_SUC_ECG_DOWNLOAD" ||
					data.RETURN_VALUE === "RV_SUC_DOWNLOAD_BLOOD")
			) {
				let holerData = {
					TYPE: data.TYPE,
					PRIVILEGE,
					...params
				};
				sendMessage(holerData);
			}
		}
		this.ConstQueryTable.consultQueryList();
	};

	downloadHolter = (record, userInfo) => {
		//单纯的下载holter文件
		let params = {
			TYPE: "HOLTER",
			PARAM: "HOLTER_DOWNLOAD",
			EXAM_UID: record.EXAM_UID,
			NAME: record.NAME,
			SERVER: window.g.baseURL,
			CA_ENABLED: window.g.CA,
			USER_INFO: userInfo
		};
		sendMessage(params);
		receiveMessage((data) => {
			if (data.RETURN_MSG === "下载成功") {
				this.refreshTable(); //刷新表格是清楚勾选项
			}
			this.setState({ tabsloading: false });
			this.getTransferStatus(data);
		});
	};

	showConfirm = (record, userInfo) => {
		//已经下载过提示
		const rolePrivilege = JSON.parse(localStorage.getItem("roleList")) || {};
		let that = this;
		if (record.CONSULTATION_DOCTOR_CODE === userInfo.USER_UID) {
			//病例已被下载过且下载的人是当前人
			confirm({
				content: "此病例已被下载，是否还要继续？",
				onOk() {
					that.downloadHolter(record, userInfo);
				},
				onCancel() {
					that.setState({
						tabsloading: false
					});
				}
			});
		} else {
			//病例已被下载过且下载的人不是当前人
			if (rolePrivilege.indexOf("审核报告") > -1) {
				//当前登陆人是否有审核权限，
				if (that.state.resultstatus === 1) {
					//当前选中数据的会诊人是都有审核权限
					message.warning("病例正在会诊中，无法下载");
					that.setState({
						tabsloading: false
					});
				} else {
					that.downloadHolter(record, userInfo); //审核人夺走报告人的病例时
				}
			} else {
				//没有审核权限的人无法夺走病例
				message.warning("病例正在会诊中，无法下载");
				that.setState({
					tabsloading: false
				});
			}
		}
	};

	getRolePrivilegeFn = (record) => {
		//报告权限
		const rolePrivilege = JSON.parse(localStorage.getItem("roleList")) || {};
		let PRIVILEGE;
		if (rolePrivilege.indexOf("审核报告") > -1 && rolePrivilege.indexOf("提交报告") > -1) {
			PRIVILEGE = "3";
		} else if (rolePrivilege.indexOf("审核报告") > -1) {
			PRIVILEGE = "1";
		} else if (rolePrivilege.indexOf("提交报告") > -1) {
			PRIVILEGE = "0";
		} else if (rolePrivilege.indexOf("查看报告") > -1) {
			PRIVILEGE = "2";
		} else if (rolePrivilege.indexOf("PDF查看") > -1) {
			PRIVILEGE = "5";
		} else {
			message.error("暂无权限，请联系管理员");
			this.setState({
				tabsloading: false
			});
			return false;
		}
		return PRIVILEGE;
	};

	handleAloneConsulation = (record) => {
		this.setState({
			rowsData: [record]
		}, () => this.handleSubmitComplete());
	};

	handleStartReporting = () => {
		// 开始报告
		const { selectedRowKeys, rowsData } = this.state;
		if (!this.canOperation(rowsData)) {
			return;
		}
		if (selectedRowKeys.length === 0) {
			Modal.info({ content: "请在列表中选择要报告的病例信息！" });
		} else if (selectedRowKeys.length === 1) {
			if (rowsData.find((item) => item.CONSULTATION_STATUS_NAME === "撤销中")) {
				return message.warning("撤回中的数据无法查看");
			} else {
				let params = {
					Type: "GetConsultationPrivilege",
					USER_UID: rowsData[0].CONSULTATION_DOCTOR_CODE
				};
				GetConsultationPrivilege(params).then((res) => {
					//开始报告之前先判断当前行数据会诊人是否有审核权限
					if (res && res.Status === 1) {
						if (res.Result === "1") {
							this.setState({
								resultstatus: 1
							});
						}
					} else {
						requestErrorLog(rowsData[0].EXAM_UID, '获取会诊人是否有审核权限接口报错', 0, true)
					}
					this.setState(
						{
							tabsloading: true
						},
						this.telemedicineFn(rowsData[0])
					);
				});
			}
		} else {
			Modal.info({ content: "请选择一条病例进行报告" });
		}
	};

	getExamImage = (EXAM_UID) => {
		// 诊断图像pdf
		printPic(EXAM_UID).then((res) => {
			if (res && res.Status === 1) {
				const picUrl = window.g.baseURL + "/" + res.Result;
				window.open(picUrl); // 打开pdf文件
				this.setState({
					tabsloading: false
				});
			} else {
				requestErrorLog(EXAM_UID, '远程会诊退回病例接口报错', 0, true)
				message.error("请求失败");
			}
		});
	};

	handleSubmitApply = () => {
		// 申请会诊
		const { rowsData } = this.state;
		const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
		if (!this.canOperation(rowsData)) {
			return;
		}
		if (rowsData.length === 0) {
			Modal.info({ content: "请选择要会诊的病例" });
		} else {
			for (let i = 0; i < rowsData.length; i++) {
				if (rowsData[i].CONSULTATION_HOSPITAL_CODE6 !== null && rowsData[i].CONSULTATION_HOSPITAL_CODE6 !== "") {
					Modal.info({ content: "申请会诊已达上限，不能申请会诊！" });
					return;
				}
				if (rowsData[i].CONSULTATION_STATUS_NAME === "撤销中") {
					Modal.info({ content: "撤销中，不允许申请会诊" });
					return;
				}
				if (rowsData[i].CONSULTATION_HOSPITAL_NAME !== userInfo.HOSPITAL_NAME) {
					Modal.info({ content: "已发送过此会诊医院，不允许重复申请" });
					return;
				}
				if (rowsData[i].EXAM_STATUS_NAME === "未检查" && rowsData[i].CONSULTATION_STATUS_NAME === "未申请") {
					Modal.info({ content: "未检查不能申请会诊" });
					return;
				} else if (rowsData[i].EXAM_STATUS_NAME === "已审核" && rowsData[i].CONSULTATION_STATUS_NAME === "已会诊") {
					Modal.info({ content: "会诊已完成不能重复申请会诊" });
					return;
				}
			}
			this.setState({
				applyVisible: true,
				applyType: "ConsultationEDIT",
				applyConsulationType: "apply"
			});
		}
	};

	handleSubmitComplete = () => {
		// 完成会诊
		const { rowsData, showKey } = this.state;
		if (!this.canOperation(rowsData)) {
			return;
		}
		const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
		if (rowsData.length === 0) {
			message.warning("请在列表中选择要完成的会诊病例！");
		} else {
			//判断是否是最终会诊医院，如果不是不允许操作
			// let shuzu = rowsData.filter((item) => item.CONSULTATION_HOSPITAL_NAME !== userInfo.HOSPITAL_NAME).map((mitem) => {
			// 	return mitem.NAME;
			// });
			// if (shuzu.length > 0) {
			// 	message.warning("最终会诊医院未审核，不能完成会诊！");
			// 	return;
			// }
			for (let i = 0; i < rowsData.length; i++) {
				const { EXAM_STATUS_NAME, CONSULTATION_STATUS_NAME, CONSULTATION_DOCTOR_CODE } = rowsData[i];

				if (EXAM_STATUS_NAME !== "已审核") {
					message.warning({ content: "请先审核，再点击完成会诊！" });
					return;
				}

				if (CONSULTATION_STATUS_NAME === "撤销中") {
					Modal.info({ content: "撤销中，无法完成会诊！" });
					return;
				}

				// if (CONSULTATION_STATUS_NAME === "未会诊" && (EXAM_STATUS_NAME === "未报告" || EXAM_STATUS_NAME === "已报告")) {
				// 	Modal.info({ content: "请先审核，再点击完成会诊" });
				// 	return;
				// }

				if (CONSULTATION_DOCTOR_CODE !== userInfo.USER_UID) {
					message.warning("不是自己的病例，不能完成会诊！");
					return;
				}

				if (EXAM_STATUS_NAME === "已审核" && CONSULTATION_STATUS_NAME === "已会诊") {
					if ([4, 5, 6].includes(parseInt(showKey))) {
						Modal.info({ content: "病例已完成会诊，无法重复操作！" });
						return;
					}
				}
			}
			this.setState({
				chooseclick: "1",
				applyType: "ConsultationEDIT"
			});
			if (parseInt(this.state.showKey) === 6) {
				// this.bloodFinished(rowsData)
				this.setState({
					//完成会诊
					applyConsulationType: "complete",
					applyVisible: true,
					completeConsultation: "blood"
				});
			} else {
				this.setState({
					//完成会诊
					applyConsulationType: "complete",
					applyVisible: true
				});
			}
		}
	};

	finishedComplete = (rowData, patientSymptom, examSuggest) => {
		// 完成会诊中间件
		const { selectedRowKeys } = this.state;
		const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
		const { automaticCompleteConsult = [] } = JSON.parse(localStorage.getItem("settingValues")) || {};
		let uid;
		// 本地没有配置自发完成会诊的时候
		if (automaticCompleteConsult.length < 1) {
			// 1.正常模式下完成会诊可多选
			uid = selectedRowKeys.length > 1 ? selectedRowKeys : [rowData.EXAM_UID];
		} else {
			//2.自发完成会诊只能操作单条数据
			uid = [rowData.EXAM_UID];
		}
		const completeData = {
			TYPE: rowData.EXAM_CLASS === "ECG" ? "ECG" : rowData.EXAM_CLASS === "Holter" ? "HOLTER" : "", // 参考TYPE类型说明
			PARAM: "FINISH_CONSULATION", // 参考PARAM参数说明
			NAME: "", // 患者姓名
			SERVER: window.g.baseURL, // 可配置的服务器地址
			CA_ENABLED: window.g.CA,
			UID_LIST: uid, // 患者的唯一id
			USER_INFO: userInfo, //登录人的用户信息
			PATIENT_SYMPTOM: patientSymptom ?? "", //患者症状 注：完成会诊后台不接收该字段，正常传防止中间件报错
			EXAM_SUGGEST: uid.length === 1 ? examSuggest : "" //诊疗建议
		};
		sendMessage(completeData);
		receiveMessage((received_msg) => {
			this.getTransferStatus(received_msg);
			this.setState({ tabsloading: false });
			if (received_msg.RETURN_MSG === "上传成功") {
				message.success("已完成会诊");
				// 自动完成会诊模式不调用患者症状及诊疗建议（动态心电患者症状及诊疗建议走中间件）
				if (rowData.EXAM_CLASS === "ECG" && automaticCompleteConsult.length < 1) {
					this.ApplyConsulation.handleEditPatientExamInfo(rowData.EXAM_UID);
				}
				this.synchData(received_msg.EXAM_UID);
				this.refreshTable();
			}
		});
	};

	messageInform = async (RequestModel) => {
		// 完成会诊消息提醒
		const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
		let Params = {
			Type: "MsgNotice",
			HOSPITAL_CODE: userInfo.HOSPITAL_CODE
		};
		const res = await msgNotice(Params, RequestModel)
		if (res && res.Status !== 1) {
			requestErrorLog('', '完成会诊消息提醒接口报错', 0, true)
		}
	};

	synchData = (EXAM_UID) => {
		// 完成会诊同步数据
		let Param = {
			Type: "SyncPatientInfo",
			EXAM_UID: EXAM_UID
		};
		finishConsultant(Param).then((res) => {
			if (res && res.Status === 1) {
				console.log("同步数据完成");
			} else {
				requestErrorLog(EXAM_UID, '远程会诊同步数据接口报错', 0, true)
				console.log("同步数据失败");
			}
		});
	};

	handleReturn = () => {
		// 退回病例只有已会诊的病例不能退回病例
		const { rowsData } = this.state;
		const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
		if (!this.canOperation(rowsData)) {
			return;
		}
		if (rowsData.length === 0) {
			message.warning("请选择要退回病例的病例信息！");
		} else if (rowsData.find((item) => item.CONSULTATION_STATUS_NAME === "已会诊")) {
			Modal.info({ content: "已会诊病例不允许退回病例" });
		} else if (rowsData.find((item) => item.CONSULTATION_STATUS_NAME === "撤销中")) {
			Modal.info({ content: "撤回中，不允许退回病例" });
		} else {
			//判断是否是最终会诊医院，如果不是不允许操作
			let shuzu = rowsData
				.filter((item) => item.CONSULTATION_HOSPITAL_NAME !== userInfo.HOSPITAL_NAME)
				.map((mitem) => {
					return mitem.NAME;
				});
			if (shuzu.length > 0) {
				message.warning({ content: "不是最终会诊医院无权限退回病例！" });
				return;
			}
			this.setState({
				backreturnvisible: true
			});
		}
	};

	backreturnreason = () => {
		// 退回病例
		const { rowsData, backreturndetail, selectedRowKeys } = this.state;
		var dataTime = new Date();
		var dateTime = moment(dataTime).format("YYYY-MM-DD HH:mm:ss");
		if (backreturndetail === "") {
			message.warning("请填写退回病例原因");
		} else {
			let applyrowsData = rowsData.map((item) => {
				return {
					...item,
					REJECT_REASON: backreturndetail,
					CONSULTATION_LOG: item.CONSULTATION_HOSPITAL_NAME + "-" + dateTime,
					CONSULTATION_STATUS: 1
				};
			});
			returnedCase(applyrowsData).then((res) => {
				if (res && res.Status === 1) {
					this.refreshTable();
					this.setState({
						rowsData: [],
						backreturnvisible: false,
						backreturndetail: ""
					});
				} else {
					requestErrorLog(selectedRowKeys.toString(), '远程会诊退回病例接口报错', 0, true)
					message.error("退回病例失败！");
				}
			});
		}
	};

	handleRevokeConsultant = () => {
		if (this.state.rowsData.length > 1) {
			return message.warning("请选择单条已会诊数据");
		}
		//已会诊状态下可以撤销
		if (this.state.rowsData[0]?.CONSULTATION_STATUS_NAME === "已会诊") {
			this.setState({
				revokeVisible: true
			});
		} else {
			message.warning("请选择已会诊的病例撤销");
		}
	};

	handleCollection = () => {
		// 收藏
		const { rowsData } = this.state;
		if (!this.canOperation(rowsData)) {
			return;
		}
		const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
		if (rowsData.length === 0) {
			message.warning("请选择要收藏的病例信息！");
		} else if (rowsData.length === 1) {
			if (rowsData[0].EXAM_STATUS_NAME === "已审核") {
				let newCOLLECTOR = rowsData[0].COLLECTOR === null ? "" : rowsData[0].COLLECTOR.trim();
				if (newCOLLECTOR.indexOf(userInfo.USER_UID) > -1) {
					message.warning("病例已收藏！");
				} else {
					this.setState({
						bookmarkVisible: true
					});
				}
			} else {
				message.warning("请选择已审核的病例进行收藏");
			}
		} else {
			message.warning("请选择单条病例进行收藏");
		}
	};

	handleUrging = () => {
		// 催办
		const { rowsData, selectedRowKeys } = this.state;
		if (!this.canOperation(rowsData)) {
			return;
		}
		const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
		if (rowsData.length === 0) {
			message.warning("请在列表中选择要操作的病例信息！");
		} else {
			if (rowsData.find((item) => item.CONSULTATION_HOSPITAL_CODE.trim() === userInfo.HOSPITAL_CODE.trim())) {
				message.warning("没有上级会诊医院");
				return;
			}
			if (rowsData.find((item) => item.CONSULTATION_STATUS === "未申请")) {
				Modal.info({ content: "还未申请会诊，不能催办" });
			} else if (rowsData.find((item) => item.CONSULTATION_STATUS === "已会诊")) {
				Modal.info({ content: "已完成会诊，不能催办" });
			} else {
				let resultdata = rowsData.map((item) => ({
					HOSPITAL_CODE: "",
					DEPT_CODE: "", //科室code不需要传
					USER_UID: userInfo.USER_UID,
					MSG_CODE: "3", //有会诊到达的消息
					MSG_DETAILED: "有【" + userInfo.HOSPITAL_NAME + "】的患者【" + item.NAME + "】催办！",
					EVENT_ID: item.EXAM_UID
				}));
				let Params = {
					Type: "Urging",
					HOSPITAL_CODE: userInfo.HOSPITAL_CODE //医院code
				};
				urging(Params, resultdata).then((res) => {
					if (res && res.Status === 1) {
						message.info("已催办！ ");
					} else {
						requestErrorLog(selectedRowKeys.toString(), '远程会诊催办接口报错', 0, true)
					}
				});
			}
		}
	};

	onClickRow = (record) => {
		// 单击行事件
		let arraylist = [];
		arraylist.push(record.EXAM_UID);
		let rowsData = [];
		rowsData.push(record);
		this.setState({
			selectedRowKeys: arraylist,
			rowData: record,
			rowsData: rowsData,
			bookmarkdetail: record.COLLECT_TAG ? record.COLLECT_TAG : "",
			submitType: "add",
			isEdit: record.COLLECT_TAG ? true : false
		});
	};

	/********************已审核已会诊的，点击只能查看********************** */
	handleDoubleClicks = async () => {
		// 双击事件
		const { rowData, rowsData } = this.state;
		if (!rowData && !rowsData) return;
		let showKey = parseInt(this.state.showKey);
		let newRowsData;
		const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
		this.setState({ tabsloading: true })
		// 列表双击下载病例前先获取该病例最新状态
		let res = await getCancelCollect(rowData.EXAM_UID);
		if (res && res.Status === 1) {
			newRowsData = res.Result;
		}
		if (newRowsData.length === 0) return;
		// 获取该病例会诊人的权限
		let params = {
			Type: "GetConsultationPrivilege",
			USER_UID: newRowsData[0].CONSULTATION_DOCTOR_CODE
		};
		GetConsultationPrivilege(params).then(async (res) => {
			if (res && res.Status === 1) {
				if (res.Result === "1") {
					this.setState({
						resultstatus: 1 //当前选中病例。0:报告权限；1：审核权限
					});
				}
			} else {
				requestErrorLog(rowData.EXAM_UID, '获取会诊人是否有审核权限接口报错', 0, true)
			}
			const rolePrivilege = JSON.parse(localStorage.getItem("roleList")) || [];
			if (JSON.stringify(rowData[0]) === JSON.stringify({})) {
				return;
			}
			if (newRowsData[0]?.CONSULTATION_STATUS_NAME === "撤销中") {
				this.setState({ tabsloading: false })
				return message.warning("撤回中的数据无法查看");
			}
			//已审核已会诊的病例以查看权限打开报告；如果是会诊医生走审核人查看、不是就只能走查看
			if (newRowsData[0].EXAM_STATUS_NAME === "已审核" && newRowsData[0].CONSULTATION_STATUS_NAME === "已会诊") {
				let index = rolePrivilege.findIndex((r) => r === "查看报告" || r === "提交报告" || r === "审核报告");
				if (rolePrivilege.indexOf("PDF查看") > -1 && index === -1) {
					this.getExamImage(newRowsData[0].EXAM_UID);
				} else {
					this.telemedicineFn(newRowsData[0]);
				}
			} else {
				if (showKey <= 3) {
					//不是最终会诊医院，不允许查看
					if (newRowsData[0].CONSULTATION_HOSPITAL_NAME !== userInfo.HOSPITAL_NAME) {
						if (
							newRowsData[0].CONSULTATION_STATUS_NAME === "会诊中" ||
							newRowsData[0].CONSULTATION_STATUS_NAME === "未会诊"
						) {
							this.setState({ tabsloading: false })
							Modal.warning({ content: "病例正在会诊中，无法查看" });
							return;
						}
					}
					// 过滤有顺序判图权限但是没有下载条件的病例
					let userConsultRecord = await getUserConsultationRecord(userInfo.USER_UID);
					if (userInfo.SEQUENCE_ANALYSIS === 1 && userConsultRecord.Result.flag === "1") {
						this.setState({ tabsloading: false })
						return message.warning("请先完成会诊中病例");
					} else {
						if (res.Status !== 1) {
							requestErrorLog('', '获取是否有会诊中的病例接口报错', 0, true)
						}
					}
				}
				//动态血压，静息心电
				if (showKey > 3) {
					if (newRowsData[0].CONSULTATION_HOSPITAL_NAME !== userInfo.HOSPITAL_NAME) {
						//到个人工作台，未会诊就不允许查看了
						if (newRowsData[0].CONSULTATION_STATUS_NAME === "未会诊") {
							this.setState({ tabsloading: false })
							Modal.info({ content: "病例正在会诊中，无法查看" });
							return;
						}
					}
				}
				this.telemedicineFn(newRowsData[0]);
			}
		});
	};

	bloodFinished = (rowData) => {
		const { rowsData, selectedRowKeys } = this.state;
		const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
		const settingValues = JSON.parse(localStorage.getItem("settingValues")) || {};
		let params = [];
		let newRowData = [];
		// 本地没有配置自发完成会诊的时候
		if (settingValues.automaticCompleteConsult.length < 1) {
			newRowData = rowsData;
		} else {
			newRowData.push(rowData);
		}
		newRowData.forEach((item) => {
			let ele = {
				NAME: item.NAME,
				CONSULTATION_UID: item.CONSULTATION_UID, //会诊病人的唯一标识UID
				EXAM_UID: item.EXAM_UID, //病人信息的唯一标识UID
				APPLY_DOCTOR_CODE: item.APPLY_DOCTOR_CODE, //申请医生code
				APPLY_DOCTOR_NAME: item.APPLY_DOCTOR_NAME, //申请医生名称
				APPLY_HOSPITAL_CODE: item.APPLY_HOSPITAL_CODE, //申请医院code
				APPLY_HOSPITAL_NAME: item.APPLY_HOSPITAL_NAME, //申请医院名称
				APPLY_DATETIME: item.APPLY_DATETIME, //申请会诊时间
				CONSULTATION_HOSPITAL_CODE: item.CONSULTATION_HOSPITAL_CODE, //会诊医院code
				CONSULTATION_HOSPITAL_NAME: item.CONSULTATION_HOSPITAL_NAME, //会诊医院名称
				CONSULTATION_STATUS: "2", //会诊状态(已完成)
				CONSULTATION_DOCTOR_CODE: userInfo.USER_UID, //会诊医生代码
				CONSULTATION_DOCTOR_NAME: userInfo.REAL_NAME, //会诊医生名称
				CONSULTATION_DATE: moment(new Date()).format("YYYY-MM-DD HH:mm"), //会诊时间（点击完成时的时间）
				CONSULTATION_FINDINGS: item.CONSULTATION_FINDINGS, //检查所见
				CONSULTATION_CONCLUSION: item.CONCLUSIONS, //诊断结论
				CONSULTATION_HOSPITAL_CODE1: item.CONSULTATION_HOSPITAL_CODE1, //一级会诊医院code
				CONSULTATION_HOSPITAL_NAME1: item.CONSULTATION_HOSPITAL_NAME1, //一级会诊医院名称
				CONSULTATION_HOSPITAL_CODE2: item.CONSULTATION_HOSPITAL_CODE2, // 二级会诊医院code
				CONSULTATION_HOSPITAL_NAME2: item.CONSULTATION_HOSPITAL_NAME2, //二级会诊医院名称
				CONSULTATION_HOSPITAL_CODE3: item.CONSULTATION_HOSPITAL_CODE3, //三级会诊医院code
				CONSULTATION_HOSPITAL_NAME3: item.CONSULTATION_HOSPITAL_NAME3, //三级会诊医院名称
				CONSULTATION_HOSPITAL_CODE4: item.CONSULTATION_HOSPITAL_CODE4, //四级会诊医院code
				CONSULTATION_HOSPITAL_NAME4: item.CONSULTATION_HOSPITAL_NAME4, //四级会诊医院名称
				CONSULTATION_HOSPITAL_CODE5: item.CONSULTATION_HOSPITAL_CODE5, //五级会诊医院code
				CONSULTATION_HOSPITAL_NAME5: item.CONSULTATION_HOSPITAL_NAME5, //五级会诊医院名称
				CONSULTATION_HOSPITAL_CODE6: item.CONSULTATION_HOSPITAL_CODE6, //六级会诊医院code
				CONSULTATION_HOSPITAL_NAME6: item.CONSULTATION_HOSPITAL_NAME6, //六级会诊医院名称
				REJECT_REASON: item.REJECT_REASON, //退回原因
				CONSULTATION_LOG: item.CONSULTATION_LOG //退回日志
			};
			params.push(ele);
		});
		completeConsultant(params).then((res) => {
			if (res && res.Status === 1) {
				message.success("完成会诊成功");
				let RequestModel = [];
				let EXAM_UIDS = [];
				params.forEach((item) => {
					EXAM_UIDS.push(item.EXAM_UID);
					RequestModel.push({
						MSG_CODE: 4,
						MSG_DETAILED: `患者【${item.NAME}】会诊完成，请查看！`,
						EVENT_ID: item.EXAM_UID,
						HOSPITAL_CODE: item.APPLY_HOSPITAL_CODE,
						USER_UID: userInfo.USER_UID
					});
				});
				EXAM_UIDS = EXAM_UIDS.join(",");
				this.messageInform(RequestModel);
				this.synchData(EXAM_UIDS);
				// 自动完成会诊模式不调用患者症状及诊疗建议
				if (settingValues.automaticCompleteConsult.length < 1) {
					this.ApplyConsulation.handleEditPatientExamInfo(newRowData[0].EXAM_UID);
				}
				this.refreshTable();
			} else {
				requestErrorLog(selectedRowKeys.toString(), '完成会诊接口报错', 0, true)
			}
		});
	};

	/********************动态血压相关结束********************** */
	setRowClassName = (record) => {
		if (record.DANGER_FLAG === 1) {
			return "danger-row";
		} else if (record === this.state.rowData) {
			return "clickRowStyl";
		} else {
			return "";
		}
	};

	handleTabKey = (key) => {
		//切换tabs
		this.props.history.push("/siderPage?key=6&applyTabskey=" + key);
		this.setState({
			showKey: key,
			PageNo: 1,
			PageSize: 10,
			selectedRowKeys: [],
			rowsData: [],
			tabsloading: true
		});
	};

	getData = (tableData, count, PageNo, PageSize) => {
		// 获取子组件数据
		this.setState({
			queryTableData: tableData,
			RowCount: count,
			PageNo: PageNo,
			PageSize: PageSize,
			tabsloading: false
		});
	};

	getConsultCount = (count) => {
		// 气泡
		this.setState({
			consultCount: count
		});
	};

	getWorkbenchCount = (count) => {
		// 个人工作台气泡
		this.setState({
			workbenchCount: count
		});
	};

	refreshTable = () => {
		//刷新列表事件
		this.setState({
			selectedRowKeys: [],
			rowsData: [],
			rowData: {}
		});
		this.ConstQueryTable.consultQueryList();
	};

	onChangePage = (page, PageSize) => {
		//每次切换页码的时候,更新之前初始化的页码
		this.setState({
			PageNo: page
		});
	};

	onSelectChange = async (selectedRowKeys) => {
		// 勾选选框事件触发
		if (selectedRowKeys.length === 1) {
			let s = "";
			s = selectedRowKeys.toLocaleString();
			if (s !== "") {
				const res = await getCancelCollect(s);
				if (res.Status === 1) {
					this.setState({
						rowsData: res.Result,
						rowData: res.Result[0],
						bookmarkdetail: res.Result[0].COLLECT_TAG ? res.Result[0].COLLECT_TAG : "",
						submitType: "add",
						isEdit: res.Result[0].COLLECT_TAG ? true : false,
						selectedRowKeys: selectedRowKeys
					});
				} else {
					console.log("请求错误");
				}
			}
		} else if (selectedRowKeys.length === 0) {
			this.setState({
				rowsData: [],
				rowData: {},
				selectedRowKeys: [],
				bookmarkdetail: "",
				submitType: "",
				isEdit: true
			});
		} else {
			let s = "";
			s = selectedRowKeys.toLocaleString();
			if (s !== "") {
				const res = await getCancelCollect(s);
				if (res.Status === 1) {
					this.setState({
						rowsData: res.Result,
						bookmarkdetail: "",
						submitType: "",
						isEdit: true,
						selectedRowKeys: selectedRowKeys
					});
				}
			}
		}
		this.setState({
			selectedRowKeys
		});
	};

	handleInputChange = (event) => {
		// 退回原因
		this.setState({ backreturndetail: event.target.value });
	};

	transferHandover = () => {
		// 移交会诊
		let { rowsData, selectedRowKeys } = this.state;
		const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
		if (rowsData.length === 0) {
			message.info("请在列表中选择要操作的病例信息！");
		} else if (rowsData.find((item) => item.CONSULTATION_STATUS_NAME === "撤销中")) {
			message.warning("撤销中，无法移交");
		} else if (rowsData.find((item) => item.CONSULTATION_STATUS_NAME === "已会诊")) {
			message.error("病例中存在已会诊数据，无法移交");
		} else {
			let str = selectedRowKeys.toLocaleString();
			let params = {
				Type: "TransferConsultation", // 移交会诊
				EXAM_UID: str, //病人信息的唯一标识UID
				USER_NAME: userInfo.REAL_NAME, // 当前登录人姓名
				USER_UID: userInfo.USER_UID
			};
			TransferConsultation(params).then((res) => {
				if (res && res.Status === 1) {
					message.success("移交成功！");
					this.refreshTable();
				} else {
					requestErrorLog(str, '移交会诊接口报错', 0, true)
					message.error("移交失败！");
				}
			});
		}
	};

	// 危急病例
	handleCriticalCase = () => {
		if (this.state.rowData.EXAM_STATUS_NAME === "已审核") {
			this.setState({
				criticalVisible: true
			})
		} else {
			message.warning("请选择已审核的病例！")
		}
	}

	handleCancelCriticalCase = () => {
		if (this.state.rowData.DANGER_FLAG === 1) {
			confirm({
				title: "取消危急值",
				content: "确定要取消危急值吗？",
				onText: "确认",
				cancelText: "取消",
				onOk: async () => {
					const res = await cancelCriticalCase(this.state.rowData.EXAM_UID)
					if (res && res.Status === 1) {
						message.success("取消危急值成功！");
						this.refreshTable();
					}
				}
			})
		} else {
			message.warning("请选择危急值病例！")
		}
	}

	handleHeader = () => {
		//点击表头
		this.setState({
			showColumn: true
		});
	};
	getCommonColumnInfo = (newTabData) => {
		//获取、更新表头设置
		newTabData = newTabData || JSON.parse(localStorage.getItem("consulationTabSetting")) || this.state.initCommonColumn;
		let commonColumn = getCommonColumnInfoFn(this.state.initCommonColumn, newTabData, "consulationTabSetting");
		this.setState({
			commonColumn
		});
	};

	render() {
		const {
			commonColumn,
			queryTableData,
			workbenchCount,
			tabsloading,
			showColumn,
			consultCount,
			showKey,
			applyVisible,
			revokeVisible,
			backreturnvisible,
			applyType,
			selectedRowKeys,
			rowsData,
			bookmarkVisible,
			isEdit,
			submitType,
			bookmarkdetail,
			rolePrivilege,
			applyConsulationType,
			completeConsultation
		} = this.state;
		const menuType = JSON.parse(localStorage.getItem("menuList")) || [];
		return (
			<div className="consulationWrapper">
				<div className="tabs_wrap">
					{(rolePrivilege.indexOf("审核报告") > -1 || rolePrivilege.indexOf("提交报告") > -1) &&
						(parseInt(showKey) > 3) ? (
						<div onClick={this.handleStartReporting}>
							<Icon type="read" className="icon" />
							<p>开始报告</p>
						</div>
					) : rolePrivilege.indexOf("查看报告") > -1 &&
						(parseInt(showKey) > 3) ? (
						<div>
							<Icon type="read" className="icon" />
							<p>查看报告</p>
						</div>
					) : null}
					{rolePrivilege.indexOf("审核报告") > -1 &&
						(parseInt(showKey) > 3) ? (
						<div onClick={this.handleSubmitComplete}>
							{/* <Icon type="robot" className="icon" /> */}
							<img
								src={reporticon}
								alt=""
								style={{
									width: "24px",
									marginLeft: "31px",
									marginBottom: "7px",
									marginTop: "2px"
								}}></img>
							<p>完成会诊</p>
						</div>
					) : null}

					{rolePrivilege.indexOf("申请会诊") > -1 &&
						(parseInt(showKey) > 3) ? (
						<div onClick={this.handleSubmitApply}>
							{/* <Icon type="laptop" className="icon" /> */}
							<img
								src={replyicon}
								style={{
									width: "30px",
									marginLeft: "29.5px",
									marginBottom: "7px",
									marginTop: "4px"
								}}
								alt=""></img>
							<p>申请会诊</p>
						</div>
					) : null}
					{parseInt(showKey) > 3 ? (
						<div onClick={this.handleUrging}>
							<Icon type="bell" className="icon" />
							<p>催办</p>
						</div>
					) : null}
					{parseInt(showKey) > 3 ? (
						<div onClick={this.transferHandover}>
							{/* <Icon type="desktop" className="icon" /> */}
							<img
								src={moveicon}
								style={{
									width: "34px",
									marginLeft: "28px",
									marginBottom: "4px",
									marginTop: "4px"
								}}
								alt=""></img>
							<p>移交会诊</p>
						</div>
					) : null}

					{parseInt(showKey) === 4 ? (
						<div onClick={this.handleCriticalCase}>
							<img src={critical} alt=""
								style={{
									width: "30px",
									marginLeft: "28px",
									marginBottom: "4px",
								}}></img>
							<p>危急病例</p>
						</div>
					) : null}

					{parseInt(showKey) === 4 ? (
						<div onClick={this.handleCancelCriticalCase}>
							<img src={cancelcritical} alt="" style={{
								width: "30px",
								marginLeft: "28px",
								marginBottom: "6px",
								marginTop: "2px",
							}}></img>
							<p>取消危急</p>
						</div>
					) : null}

					<div onClick={this.handleCollection}>
						{/* <Icon type="solution" className="icon" /> */}
						<img
							src={star}
							alt=""
							style={{
								width: "26px",
								marginLeft: "31px",
								marginBottom: "5px",
								marginTop: "2px"
							}}></img>
						<p>病例收藏</p>
					</div>
					{parseInt(showKey) > 3 ? (
						<div onClick={this.handleReturn}>
							<Icon type="rollback" className="icon" />
							<p>退回病例</p>
						</div>
					) : null}

					{parseInt(showKey) > 3 ? (
						<div onClick={this.handleRevokeConsultant}>
							<Icon type="select" className="icon" />
							<p>撤销会诊</p>
						</div>
					) : null}
				</div>

				{bookmarkVisible ? (
					<Bookmark
						visible={bookmarkVisible}
						isEdit={isEdit}
						bookmarkdetail={bookmarkdetail}
						submitType={submitType}
						refreshTable={this.refreshTable}
						rowData={rowsData.length > 0 ? rowsData[0] : []}
						onRef={(ref) => {
							this.setState({ bookmarkVisible: ref });
						}}></Bookmark>
				) : null}

				{revokeVisible ? (
					<RevokeConsultant
						visible={revokeVisible}
						showKey={showKey}
						refreshTable={this.refreshTable}
						rowData={rowsData.length > 0 ? rowsData[0] : []}
						onRef={(ref) => {
							this.setState({ revokeVisible: ref });
						}}></RevokeConsultant>
				) : null}

				{applyVisible ? (
					<ApplyConsulation
						visible={applyVisible}
						rowData={rowsData}
						selectedRowKeys={selectedRowKeys}
						applyConsulationType={applyConsulationType}
						completeConsultation={completeConsultation}
						refreshTable={this.refreshTable}
						finishedComplete={this.finishedComplete}
						bloodFinished={this.bloodFinished}
						applyType={applyType}
						onConsultationRef={(ref) => {
							this.ApplyConsulation = ref;
						}}
						onRef={(ref) => {
							this.setState({ applyVisible: ref });
						}}
					/>
				) : null}

				<ConstQueryTable
					getData={this.getData}
					setConsultCount={this.getConsultCount}
					setWorkbenchCount={this.getWorkbenchCount}
					getMessageFn={this.props.getMessageFn}
					data={showKey}
					onRef={(ref) => {
						this.ConstQueryTable = ref;
					}}
					PageNo={this.state.PageNo}
					PageSize={this.state.PageSize}
				/>

				{/* 设置表头 */}
				{showColumn ? (
					<EditTable
						visible={showColumn}
						setTabData={JSON.parse(localStorage.getItem("consulationTabSetting")) || this.state.initCommonColumn}
						updateParent={this.getCommonColumnInfo}
						onRef={(ref) => {
							this.setState({ showColumn: ref.showColumn });
						}}
					/>
				) : null}

				{this.state.criticalVisible ?
					<CriticalCaseInfo
						visible={this.state.criticalVisible}
						rowData={this.state.rowData}
						refreshTable={this.refreshTable}
						onRef={(ref) => {
							this.setState({ criticalVisible: ref });
						}}
					/>
					: null}

				{this.state.deepSeekModalVisible ? (
					<DeepSeekModal
						visible={this.state.deepSeekModalVisible}
						deepSeekModalPatientPart={this.state.deepSeekModalPatientPart}
						deepSeekModalType={this.state.deepSeekModalType}
						onRef={(ref) => {
							this.setState({
								deepSeekModalVisible: ref,
							});
							this.refreshTable()
						}}
					>

					</DeepSeekModal>
				) : null}
				<div className="eleWrap consulationId">
					<Spin size="large" spinning={tabsloading} tip="Loading...">
						<Tabs activeKey={showKey + ""} type="card" onChange={this.handleTabKey}>
							{menuType.indexOf("静息心电") > -1 ? (
								<TabPane
									key="1"
									tab={
										<Badge size="default" count={consultCount.ECG}>
											<p className="badgeText">静息心电</p>
										</Badge>
									}>
									{/* <Spin size="large" spinning={tabsloading} tip="Loading..."> */}
									<Table
										columns={commonColumn}
										rowSelection={{
											selectedRowKeys,
											onChange: this.onSelectChange
										}}
										dataSource={queryTableData}
										rowKey={(record) => record.EXAM_UID} // 需要修改为唯一的ID！
										scroll={{ x: 380, scrollToFirstRowOnChange: true }}
										pagination={{
											total: this.state.RowCount,
											current: this.state.PageNo,
											onChange: this.onChangePage
										}}
										onRow={(record) => {
											return {
												onClick: (e) => {
													this.onClickRow(record);
												}, //点击行
												onDoubleClick: (e) => {
													this.handleDoubleClicks(record);
												} //双击行
											};
										}}
										rowClassName={this.setRowClassName} //表格样式
										onHeaderRow={(column) => {
											return {
												onDoubleClick: (e) => this.handleHeader(column) //修改表头
											};
										}}
									/>
									{/* </Spin> */}
								</TabPane>
							) : null}
							{menuType.indexOf("动态心电") > -1 ? (
								<TabPane
									key="2"
									tab={
										<Badge size="default" count={consultCount.Holter}>
											<p className="badgeText">动态心电</p>
										</Badge>
									}>
									{/* <Spin size="large" spinning={tabsloading} tip="Loading..."> */}
									<Table
										columns={commonColumn}
										rowSelection={{
											selectedRowKeys,
											onChange: this.onSelectChange
										}}
										dataSource={queryTableData}
										rowKey={(record) => record.EXAM_UID} // 需要修改为唯一的ID！
										scroll={{ x: 380, scrollToFirstRowOnChange: true }}
										pagination={{
											total: this.state.RowCount,
											current: this.state.PageNo,
											onChange: this.onChangePage
										}}
										onRow={(record) => {
											return {
												onClick: (e) => {
													this.onClickRow(record);
												}, //点击行
												onDoubleClick: (e) => {
													this.handleDoubleClicks(record);
												} //双击行
											};
										}}
										rowClassName={this.setRowClassName} //表格样式
										onHeaderRow={(column) => {
											return {
												onDoubleClick: (e) => this.handleHeader(column) //修改表头
											};
										}}
									/>
									{/* </Spin> */}
								</TabPane>
							) : null}
							{menuType.indexOf("动态血压") > -1 ? (
								<TabPane
									key="3"
									tab={
										<Badge size="default" count={consultCount.BloodPressure}>
											<p className="badgeText">动态血压</p>
										</Badge>
									}>
									{/* <Spin size="large" spinning={tabsloading} tip="Loading..."> */}
									<Table
										columns={commonColumn}
										rowSelection={{
											selectedRowKeys,
											onChange: this.onSelectChange
										}}
										dataSource={queryTableData}
										rowKey={(record) => record.EXAM_UID} // 需要修改为唯一的ID！
										scroll={{ x: 380, scrollToFirstRowOnChange: true }}
										pagination={{
											total: this.state.RowCount,
											current: this.state.PageNo,
											onChange: this.onChangePage
										}}
										onRow={(record) => {
											return {
												onClick: (e) => {
													this.onClickRow(record);
												}, // 点击行
												onDoubleClick: (e) => {
													this.handleDoubleClicks(record);
												} //双击行
											};
										}}
										rowClassName={this.setRowClassName} //表格样式
										onHeaderRow={(column) => {
											return {
												onDoubleClick: (e) => this.handleHeader(column) //修改表头
											};
										}}
									/>
									{/* </Spin> */}
								</TabPane>
							) : null}
							{menuType.indexOf("静息心电") > -1 ? (
								<TabPane
									key="4"
									tab={
										<Badge size="default" count={workbenchCount.ECG}>
											<p className="badgeText">个人工作台-静息心电</p>
										</Badge>
									}>
									{/* <Spin size="large" spinning={tabsloading} tip="Loading..."> */}
									<Table
										columns={commonColumn}
										rowSelection={{
											selectedRowKeys,
											onChange: this.onSelectChange
										}}
										dataSource={queryTableData}
										rowKey={(record) => record.EXAM_UID} // 需要修改为唯一的ID！
										scroll={{ x: 380, scrollToFirstRowOnChange: true }}
										pagination={{
											total: this.state.RowCount,
											current: this.state.PageNo,
											onChange: this.onChangePage
										}}
										onRow={(record) => {
											return {
												onClick: (e) => {
													this.onClickRow(record);
												}, //点击行
												onDoubleClick: (e) => {
													this.handleDoubleClicks(record);
												} //双击行
											};
										}}
										rowClassName={this.setRowClassName} //表格样式
										onHeaderRow={(column) => {
											return {
												onDoubleClick: (e) => this.handleHeader(column) //修改表头
											};
										}}
									/>
									{/* </Spin> */}
								</TabPane>
							) : null}
							{menuType.indexOf("动态心电") > -1 ? (
								<TabPane
									key="5"
									tab={
										<Badge size="default" count={workbenchCount.Holter}>
											<p className="badgeText">个人工作台-动态心电</p>
										</Badge>
									}>
									{/* <Spin size="large" spinning={tabsloading} tip="Loading..."> */}
									<Table
										columns={commonColumn}
										rowSelection={{
											selectedRowKeys,
											onChange: this.onSelectChange
										}}
										dataSource={queryTableData}
										rowKey={(record) => record.EXAM_UID} // 需要修改为唯一的ID！
										scroll={{ x: 380, scrollToFirstRowOnChange: true }}
										pagination={{
											total: this.state.RowCount,
											current: this.state.PageNo,
											onChange: this.onChangePage
										}}
										onRow={(record) => {
											return {
												onClick: (e) => {
													this.onClickRow(record);
												}, //点击行
												onDoubleClick: (e) => {
													this.handleDoubleClicks(record);
												} //双击行
											};
										}}
										rowClassName={this.setRowClassName} //表格样式
										onHeaderRow={(column) => {
											return {
												onDoubleClick: (e) => this.handleHeader(column) //修改表头
											};
										}}
									/>
									{/* </Spin> */}
								</TabPane>
							) : null}
							{menuType.indexOf("动态血压") > -1 ? (
								<TabPane
									key="6"
									tab={
										<Badge size="default" count={workbenchCount.BloodPressure}>
											<p className="badgeText">个人工作台-动态血压</p>
										</Badge>
									}>
									{/* <Spin size="large" spinning={tabsloading} tip="Loading..."> */}
									<Table
										columns={commonColumn}
										rowSelection={{
											selectedRowKeys,
											onChange: this.onSelectChange
										}}
										dataSource={queryTableData}
										rowKey={(record) => record.EXAM_UID} // 需要修改为唯一的ID！
										scroll={{ x: 380, scrollToFirstRowOnChange: true }}
										pagination={{
											total: this.state.RowCount,
											current: this.state.PageNo,
											onChange: this.onChangePage
										}}
										onRow={(record) => {
											return {
												onClick: (e) => {
													this.onClickRow(record);
												}, //点击行
												onDoubleClick: (e) => {
													this.handleDoubleClicks(record);
												} //双击行
											};
										}}
										rowClassName={this.setRowClassName} //表格样式
										onHeaderRow={(column) => {
											return {
												onDoubleClick: (e) => this.handleHeader(column) //修改表头
											};
										}}
									/>
									{/* </Spin> */}
								</TabPane>
							) : null}
						</Tabs>
					</Spin>
				</div>
				{/* 退回病例原因 */}
				{backreturnvisible ? (
					<Modal
						className="consulationH"
						width={440}
						title="退回病例"
						visible={backreturnvisible}
						footer={[
							<Button key="save" type="primary" onClick={this.backreturnreason}>
								确定
							</Button>,
							<Button
								key="exit"
								type="primary"
								onClick={() => {
									this.setState({
										backreturnvisible: false
									});
								}}>
								取消
							</Button>
						]}
						onCancel={() => {
							this.setState({
								backreturnvisible: false
							});
						}} // 右上角的关闭按钮
					>
						<div style={{ padding: "10px" }}>
							<p className="backreson">退回原因：</p>
							<TextArea
								maxLength={128}
								style={{ width: "320px" }}
								placeholder="请输入退回原因，最长不要超过128个字符"
								onChange={this.handleInputChange}
								defaultValue={this.state.backreturndetail}
							/>
						</div>
					</Modal>
				) : null}
			</div>
		);
	}
}

export default RemoteConsulation;
